export default "__VITE_ASSET__CU77JBP___"